import { Suspense, lazy } from "react";

import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import useTheme from "@mui/material/styles/useTheme";

import CircularProgress from "components/circular-progress";

import { useNeonNow } from "./use-neon-now.hook";

// Lazy load the NeonNow component so the iframe only loads when actually needed
const NeonNow = lazy(() => import("./index"));

export default function NeonNowDrawer() {
  const theme = useTheme();
  const { isOpen, handleClose, rightOffset, iframeRef } = useNeonNow();

  return (
    <Drawer
      PaperProps={{
        sx: {
          width: rightOffset,
          top: "74px"
        }
      }}
      variant="persistent"
      anchor="right"
      sx={{
        zIndex: theme.zIndex.snackbar
      }}
      open={isOpen}
      onClose={handleClose}
    >
      <Box height="100%" overflow="hidden">
        {isOpen && (
          <Suspense
            fallback={
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <CircularProgress />
              </Box>
            }
          >
            <NeonNow iframeRef={iframeRef} />
          </Suspense>
        )}
      </Box>
    </Drawer>
  );
}
